import {UIRouterReact} from '@uirouter/react';

interface RouterConfigOptions {
  persistRouter: (router: UIRouterReact) => void;
}

export const RouterConfig = (config: RouterConfigOptions) => (router: UIRouterReact) => {
  const {persistRouter} = config;

  // router.stateService.defaultErrorHandler(() => {}); // Disable error displaying

  persistRouter(router);
};
